import React from 'react';
import { createRoot } from 'react-dom/client';
import EanCheckApp from './EanCheckApp';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const container = document.getElementById('js-ean-check')!;
const root = createRoot(container);
const queryClient = new QueryClient();

root.render(
    <QueryClientProvider client={queryClient}>
        <EanCheckApp />
    </QueryClientProvider>
);